<template>
  <b-card no-body class="pin-filter-panel">
    <div class="filter-topbar px-1 pt-75 pb-50">
      <div class="d-flex justify-content-between align-items-center mb-75">
        <span class="font-weight-bold" style="font-size: 0.95rem; color: #5e5873;">Quick Search</span>
        <b-button variant="primary" size="sm" :to="{ name: 'pin-create' }">
          <feather-icon icon="PlusIcon" size="14" class="mr-25" />Add Property Pin
        </b-button>
      </div>

      <div class="d-flex flex-wrap" style="gap: 0.5rem; align-items: flex-end;">

        <!-- ID -->
        <div class="topbar-field-sm">
          <label class="topbar-input-label">ID</label>
          <div class="position-relative">
            <input
              v-model="form.byID"
              type="text"
              class="form-control topbar-clearable"
              placeholder="ID"
              autocomplete="off"
              @input="debouncedSubmit"
              @keyup.enter="submit"
            />
            <span v-if="form.byID" class="topbar-clear-btn" @mousedown.prevent="form.byID = ''; debouncedSubmit()"><feather-icon icon="XIcon" size="10" /></span>
          </div>
        </div>

        <!-- Name -->
        <div class="topbar-field-code">
          <label class="topbar-input-label">Name</label>
          <div class="position-relative">
            <input
              v-model="form.keyword"
              type="text"
              class="form-control topbar-clearable"
              placeholder="property name..."
              autocomplete="off"
              @input="debouncedSubmit"
              @keyup.enter="submit"
            />
            <span v-if="form.keyword" class="topbar-clear-btn" @mousedown.prevent="form.keyword = ''; debouncedSubmit()"><feather-icon icon="XIcon" size="10" /></span>
          </div>
        </div>

        <!-- Rate -->
        <div class="topbar-field-sm">
          <label class="topbar-input-label">Rate</label>
          <v-select v-model="form.byRating" :options="rateOptions" label="text" :reduce="o => o.value" :clearable="false" placeholder="All" @input="submit" />
        </div>

        <!-- Zone -->
        <div class="topbar-field-md">
          <label class="topbar-input-label">Zone</label>
          <v-select v-model="form.byZone" :options="zoneData" label="name" :reduce="o => o.id" placeholder="All zones" @input="submit" />
        </div>

        <!-- BTS -->
        <div class="topbar-field-md">
          <label class="topbar-input-label">BTS</label>
          <v-select v-model="form.byBTS" :options="btsData" label="name" :reduce="o => o.id" placeholder="All BTS" @input="submit" />
        </div>

        <!-- MRT -->
        <div class="topbar-field-md">
          <label class="topbar-input-label">MRT</label>
          <v-select v-model="form.byMRT" :options="mrtData" label="name" :reduce="o => o.id" placeholder="All MRT" @input="submit" />
        </div>

        <!-- Airport Link -->
        <div class="topbar-field-md">
          <label class="topbar-input-label">Airport Link</label>
          <v-select v-model="form.byAirportlink" :options="airportData" label="name" :reduce="o => o.id" placeholder="All Airport Link" @input="submit" />
        </div>

        <!-- Tags -->
        <div class="topbar-field-md">
          <label class="topbar-input-label">Tags</label>
          <v-select v-model="form.byTags" :options="tagsData" label="name" :reduce="o => o.id" placeholder="All Tags" multiple @input="submit" />
        </div>
      </div>
    </div>

    <!-- Active filter capsules -->
    <div v-if="chips.length" class="capsule-row px-1 py-50 border-top">
      <b-badge
        v-for="chip in chips"
        :key="chip.key"
        class="capsule-tag mr-25 mb-25 d-inline-flex align-items-center cursor-pointer"
        @click="clearChip(chip.key)"
      >
        <span class="capsule-label">{{ chip.label }}</span>
        <span class="capsule-value">{{ chip.value }}</span>
        <feather-icon icon="XIcon" size="10" class="ml-25 capsule-x" />
      </b-badge>
      <b-badge class="capsule-tag capsule-clear mr-25 mb-25 d-inline-flex align-items-center cursor-pointer" @click="reset">
        <feather-icon icon="XIcon" size="10" class="mr-25" />Clear All
      </b-badge>
    </div>
  </b-card>
</template>

<script>
import { BCard, BButton, BBadge } from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  name: 'PinFilterPanel',
  components: { BCard, BButton, BBadge, vSelect },
  props: {
    initialFilter: { type: Object, default: () => ({}) },
    zoneData:      { type: Array,  default: () => [] },
    btsData:       { type: Array,  default: () => [] },
    mrtData:       { type: Array,  default: () => [] },
    airportData:   { type: Array,  default: () => [] },
    tagsData:      { type: Array,  default: () => [] },
  },
  data() {
    return {
      form: {
        byID: '',
        keyword: '',
        byRating: null,
        byZone: null,
        byBTS: null,
        byMRT: null,
        byAirportlink: null,
        byTags: [],
      },
      appliedForm: null,
      submitDebounceTimer: null,
      rateOptions: [
        { value: null, text: 'All' },
        { value: '1', text: '1' },
        { value: '2', text: '2' },
        { value: '3', text: '3' },
        { value: '4', text: '4' },
        { value: '5', text: '5' },
      ],
    }
  },
  computed: {
    chips() {
      const f = this.appliedForm
      if (!f) return []
      const list = []
      if (f.byID)     list.push({ key: 'byID',     label: 'ID',   value: f.byID })
      if (f.keyword)  list.push({ key: 'keyword',  label: 'Name', value: f.keyword })
      if (f.byRating) list.push({ key: 'byRating', label: 'Rate', value: f.byRating })
      if (f.byZone) {
        const z = this.zoneData.find(o => o.id == f.byZone)
        list.push({ key: 'byZone', label: 'Zone', value: z ? z.name : f.byZone })
      }
      if (f.byBTS) {
        const b = this.btsData.find(o => o.id == f.byBTS)
        list.push({ key: 'byBTS', label: 'BTS', value: b ? b.name : f.byBTS })
      }
      if (f.byMRT) {
        const m = this.mrtData.find(o => o.id == f.byMRT)
        list.push({ key: 'byMRT', label: 'MRT', value: m ? m.name : f.byMRT })
      }
      if (f.byAirportlink) {
        const a = this.airportData.find(o => o.id == f.byAirportlink)
        list.push({ key: 'byAirportlink', label: 'Airport Link', value: a ? a.name : f.byAirportlink })
      }
      if (f.byTags && f.byTags.length) {
        f.byTags.forEach(id => {
          const t = this.tagsData.find(o => o.id == id)
          list.push({ key: `byTags:${id}`, label: 'Tag', value: t ? t.name : id })
        })
      }
      return list
    },
  },
  mounted() {
    this.applyInitialFilter()
  },
  beforeDestroy() {
    clearTimeout(this.submitDebounceTimer)
  },
  methods: {
    applyInitialFilter() {
      const f = this.initialFilter
      if (!f || !Object.keys(f).length) return
      Object.keys(this.form).forEach(k => { if (f[k] !== undefined && f[k] !== null) this.form[k] = f[k] })
      this.appliedForm = { ...this.form }
    },
    submit() {
      clearTimeout(this.submitDebounceTimer)
      this.appliedForm = { ...this.form }
      this.$emit('apply-filter', { ...this.form })
    },
    debouncedSubmit() {
      clearTimeout(this.submitDebounceTimer)
      this.submitDebounceTimer = setTimeout(() => this.submit(), 500)
    },
    reset() {
      this.form = { byID: '', keyword: '', byRating: null, byZone: null, byBTS: null, byMRT: null, byAirportlink: null, byTags: [] }
      this.appliedForm = null
      this.$emit('clear-filter')
    },
    clearChip(key) {
      if (key.startsWith('byTags:')) {
        const id = key.slice('byTags:'.length)
        this.form.byTags = this.form.byTags.filter(v => v != id)
      } else {
        this.form[key] = (key === 'byID' || key === 'keyword') ? '' : null
      }
      this.submit()
    },
  },
}
</script>

<style scoped>
.filter-topbar { border-bottom: 1px solid #ebe9f1; }

.topbar-input-label { display: block; font-size: 0.72rem; font-weight: 600; color: #5e5873; margin-bottom: 0.25rem; white-space: nowrap; }
.topbar-field-sm { width: 130px; flex-shrink: 0; }
.topbar-field-md { width: 180px; flex-shrink: 0; }
.topbar-field-code { min-width: 180px; flex: 2; }
.topbar-clearable { padding-right: 1.4rem !important; }
.topbar-clear-btn { position: absolute; right: 0.45rem; top: 50%; transform: translateY(-50%); cursor: pointer; color: #6e6b7b; background: #d8d6de; border-radius: 50%; width: 16px; height: 16px; display: flex; align-items: center; justify-content: center; flex-shrink: 0; z-index: 2; }
.topbar-clear-btn:hover { background: #ea5455; color: #fff; }

.topbar-field-sm ::v-deep .vs__dropdown-toggle,
.topbar-field-md ::v-deep .vs__dropdown-toggle {
  min-height: 38px;
  background-color: #fff;
}

/* Active filter capsules */
.capsule-row { display: flex; flex-wrap: wrap; align-items: center; background: transparent; }
.capsule-tag {
  display: inline-flex;
  align-items: center;
  padding: 0.3rem 0.65rem;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 500;
  background: #e6f4ea;
  color: #2d7a3a;
  border: 1px solid #a8d5b0;
  cursor: pointer;
  transition: background 0.15s, opacity 0.15s;
  gap: 0.2rem;
}
.capsule-tag:hover { background: #d0ecd6; }
.capsule-label { color: #5da867; font-weight: 400; margin-right: 0.2rem; }
.capsule-value { font-weight: 600; }
.capsule-x { opacity: 0.6; flex-shrink: 0; }
.capsule-clear { background: #fff0f0; color: #e63946; border-color: #f5c6cb; }
.capsule-clear:hover { background: #ffd6d6; }
</style>
